import Parse from 'parse';
import React from 'react';
import $ from "jquery";
class postSaveUser extends React.Component {
    constructor(props) {
        super(props);
        var posts_id='';
        var post_id=props.postIdData;
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;        
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Save');  
          checksavequery.equalTo('photo', "Photo$"+props.postIdData);
          checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
          checksavequery.find().then(function(resultSave){
              if(resultSave)
              {             
                  let resultSaved=resultSave[0];
                  resultSavedid= resultSaved.id;
                  let photo_id= resultSaved.get('photo').id;
                  if(resultSavedid)
                  {  
                    
                      $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                      $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: block");
                      $('a.savepost_link1#save_'+post_id).attr("style", "pointer-events: auto"); 
                      if(posts_id)
                      {
                          $('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style", "display: none"); 
                          $('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style", "display: block");
                      }

                     
                  }  
              }
          })
        }
    }
    render() {
        return '';
    }
}
export default postSaveUser;


// WEBPACK FOOTER //
// ./src/postSaveUser.jsx